import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import useLenis from "@/lib/useLenis";
import useCursor from "@/lib/useCursor";
import Hero from "@/components/Hero";

const Home = () => {
  useLenis();
  useCursor();

  return (
    <main data-testid="landing-root" className="bg-white text-[#0A0A0C]">
      <Hero />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
